import type { Video as VideoType } from '@type-declarations/media';

import MuxVideo from './MuxVideo';
import YoutubeVideo from './YoutubeVideo';

interface Props {
  video: Partial<VideoType>;
  className?: string | false;
  autoplay?: boolean;
  loop?: boolean;
  controls?: boolean;
  showCustomControls?: boolean;
}

function Video({
  video: { youtubeId, embeddedVideo, alt = '', thumbnail },
  autoplay = false,
  loop = false,
  controls,
  className,
  showCustomControls = false,
}: Props) {
  if (!youtubeId && !embeddedVideo) {
    return null;
  }

  if (youtubeId) {
    return (
      <YoutubeVideo
        youtubeId={youtubeId}
        className={className}
        autoplay={autoplay}
        loop={loop}
        showCustomControls={showCustomControls}
      />
    );
  }

  if (embeddedVideo) {
    return (
      <MuxVideo
        className={className}
        video={embeddedVideo}
        autoplay={autoplay}
        loop={loop}
        alt={alt}
        thumbnail={thumbnail}
        controls={controls}
        showCustomControls={showCustomControls}
      />
    );
  }
}

export default Video;
